<template>
  <div class="all" >
    <p>共{{listData.datas.length}}个证件</p>
    <div class="listItem" v-for='(item,index) in listData.datas'>
      <div class="clear">
        <div class="fl key">{{item.otherInfoMap[0].key}}:</div>
        <div class="fl value">{{item.otherInfoMap[0].value}}</div>
      </div>
      <div class="clear ">
        <div class="fl key">{{item.otherInfoMap[1].key}}:</div>
        <div class="fl value">{{item.otherInfoMap[1].value}}</div>
      </div>
      <span class="look" @click='toLook(index)'>
        查看证照
      </span>
    </div>
  </div>
</template>

<script>
import store from '../store.js'
import { MessageBox,Toast,Indicator } from 'mint-ui'
import QRCode from 'qrcodejs2';
export default {
  name: 'App',
  data () {
    return {
      listData:store.state.listData
    }
  },
  mounted() {        //写在mounted或者activated生命周期内即可
  },
  created(){
    console.log(this.listData);
  },
  methods:{
    toLook(ind){
      sessionStorage.swiper_index=ind;
      history.go(-1);
    }
  }
}
</script>

<style lang='scss' scoped="">
.all {
  padding: 0 10px;
  margin-top: -10px;
  p {
    font-size: 16px;
  }
  .listItem {
    position: relative;
    background: #fff;
    border-left: 4px solid #2F7BEC;
    margin-bottom: 10px;
    padding: 10px;
    font-size: 16px;
    box-shadow: 0 2px 10px -4px rgba(0,0,0,0.15);
    .clear {
      clear: both;
      overflow: hidden;
      width: 70%;
      margin-bottom: 5px;
      .fl {
        float: left;
      }
      .key {
        color: #999999;
        margin-right: 2%;
        width: 32%;
      }
      .value {
        width: 65%;
      }
    }
    .look {
      background: #2F7BEC;
      border-radius: 40px;
      font-size: 14px;
      padding: 6px 16px;
      color: #fff;
      position: absolute;
      right: 10px;
      top: 50%;
      margin-top: -15px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/index/components/all.vue